<template>
<div class="container p-4">
<div class="row">

    <div class="alert alert-primary">
        <strong>Crop the area that the algorithm schoud trace. Here you can
            make shure that Metadata like Scales or Timestamps not being
            traced. </strong>.
    </div>
    <div class="text-center">
        <div class="spinner-border" style="width: 50%; height: 3rem; margin: 0 auto;" role="status" v-if="loading">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <div class="col-md-12 mb-1">
        <button class="btn btn-primary" v-if="!manual" @click="manual = !manual"> Manual Input</button>
        <button class="btn btn-primary" v-if="manual" @click="manual = !manual"> Graphical Input</button>
    </div>
    <div class="col-md-6" v-if="!manual">
        <clipper-basic ref="clipper" class="" :src="image.src" @load="loadCb" :initWidth="100" :initHeight="100"></clipper-basic>
    </div>
    <div class="col-md-12" v-if="manual">
    	    
            <label>top</label>
            <div class="input-group">
                <input type="number" class="form-control" name="top" v-model="top" @change="updateCropper" />
            </div>

            <label>left</label>
            <div class="input-group">
                <input type="number" class="form-control" name="left" v-model="left" @change="updateCropper" />
            </div>

            <label>width</label>
            <div class="input-group">
                <input type="number" class="form-control" name="width" v-model="width" @change="updateCropper" />
            </div>

            <label>height</label>
            <div class="input-group">
                <input type="number" class="form-control" name="height" v-model="height" @change="updateCropper" />
            </div>

        </div>
   
        <!-- Cropped image previewer -->
    </div>
    </div>
</template>

<script>
export default {
    props: ["image", "form"],
    components: {},
    data() {
        return {
            croppedImageSrc: "",
            loading: false,
            crop: "",
            cropValues: "",
            top: 0,
            left: 0,
            width: 0,
            height: 0,
            originalWidth: null,
            originalHeight: null,
            manual: false
        };
    },
    mounted() {

        this.$refs.clipper.onChange$.subscribe(() => {
            this.cropImage();
        });
    },
    computed: {

    },
    methods: {
        loadCb() {
            console.log("set new image");
            this.$refs.clipper.setTL$.next({
                top: 0, // 0%
                left: 0
            })
            this.$refs.clipper.setWH$.next({
                width: 100, // 100%
                height: 100
            })

            var drawPos = this.$refs.clipper.getDrawPos();
            

        },
        updateCropper(){


            var b1 = parseInt(this.width)+parseInt(this.left);
            var b2 = parseInt(this.height)+parseInt(this.top);

            this.form.crop = this.top +" "+ this.left +" "+ b1 +" "+ b2;

             console.log(this.form.crop);

        },
        cropImage() {
            // Get image data for post processing, e.g. upload or setting image src

            var drawPos = this.$refs.clipper.getDrawPos();


            //this.pixel = `${canvas.width} x ${canvas.height}`;
            //console.log(JSON.stringify(this.$refs.clipper.zoomTL$));
            //console.log(JSON.stringify(this.$refs.clipper.zoomWH$));

            //console.log("canvas: "+ canvas.height+" " + canvas.width);
            //console.log("clipper: "+this.$refs.clipper.zoomTL$.top+ " " +this.$refs.clipper.zoomTL$.left+ " "+this.$refs.clipper.zoomWH$.width +" "+this.$refs.clipper.zoomWH$.height  +" ");
            var top, left, width, height;
            
                top = 
                Math.floor(
                    drawPos.pos.sy
                );

                left = 
                Math.floor(
                    drawPos.pos.sx
                );

               width = 
                Math.floor(
                    drawPos.pos.swidth
                );

                height = 
                Math.floor(
                    drawPos.pos.sheight
                );
                this.width = drawPos.swidth
                this.height = drawPos.sheight 

                this.form.crop = top +" "+ left +" "+ width +" "+ height;

            console.log(this.form.crop);

        },
        ready() {
            this.loading = false;
            //console.log("ready");
        },
        change() {
            //console.log("loading");
        }
    }
};
</script>
